// extracted by mini-css-extract-plugin
module.exports = {"container":"MainMobileCarousel_container__z8SnO","swiper":"MainMobileCarousel_swiper__3gRe0","slide":"MainMobileCarousel_slide__J7AfW"};